module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-clearfix"
  }, [_c('a', {
    staticClass: "is-pulled-right has-text-centered lxm-login-attached-button__right",
    on: {
      "click": _vm.rightClicked
    }
  }, [_vm._v(_vm._s(_vm.rightText))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1bb8717c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bb8717c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/common/AttachedButton.vue
// module id = 822
// module chunks = 0